import Vue from 'vue'
import Router from 'vue-router'

import store from '@/services/store'

import PublicLayout from '@/views/Public/Layout'
import PrivateLayout from '@/views/Private/Layout'

import PublicRoutes from './publicRoutes'
import PrivateRoutes from './privateRoutes'

Vue.use(Router)

const router = new Router({
	mode: 'history',
	scrollBehavior: (to, from, savedPosition) => {
		return savedPosition || { x: 0, y: 0 }
	},
	routes: [
		{
			path: '/',
			component: PublicLayout,
			children: PublicRoutes
		},
		{
			path: '/',
			component: PrivateLayout,
			children: PrivateRoutes,
			meta: {
				requiresAuth: true
			}
		}
	]
})

router.beforeEach((to, from, next) => {

	store.dispatch('setLoading', true)
	store.dispatch('setReady', false)
	store.dispatch('setNavigationState', false)
	store.dispatch('setLeaveConfirmation', {
		changed: false,
		show: false,
		path: null
	})

	// allow access to protected pages only to logged user
	if (
		to.matched.some(record => record.meta.requiresAuth)
		&& !store.state.auth.access_token
	) {
		next('/login')
		return
	}

	// redirect to login page if token is missing
	if (
		!to.params.token
		&& (
			to.fullPath === '/reset-password'
			|| to.fullPath === '/confirm-email'
			|| to.fullPath === '/verify'
			|| to.fullPath === '/invitation'
			)
		)
	{
		next('/login')
		return
	}

	// prevent visit billing page if settings are missing
	if (
		to.fullPath === '/account/billing'
		&& store.state.userTeam.settings.billingSet === 'false'
	) {
		next(process.env.VUE_APP_DEFAULT_PAGE)
		return
	}

	// prevent logged user to visit onboarding pages
	if (
		store.state.auth.access_token
		&&
		(
			to.fullPath === '/login'
			|| to.fullPath === '/register'
			|| to.fullPath === '/confirm-email'
			|| to.fullPath === '/forgotten-password'
			|| to.fullPath === '/reset-password'
		)
	) {
		next(process.env.VUE_APP_DEFAULT_PAGE)
		return
	}

	// allow only admin to visit administration pages
	if (
		to.fullPath === '/administration/languages'
		|| to.fullPath === '/administration/environment'
		|| to.fullPath === '/administration/accounts'
	) {
		if (store.state.user.roles.findIndex(item => item.name === 'ADMIN') === -1) {
			next('/')
			return
		}
	}

	// prevent guest to visit administration pages
	if (
		store.state.guestId !== ''
		&&
		(
			to.fullPath === '/administration/accounts'
			|| to.fullPath === '/administration/languages'
			|| to.fullPath === '/administration/environment'
		)
	) {
		next(process.env.VUE_APP_DEFAULT_PAGE)
		return
	}

	// allow only team owner and team admin to see pages
	if (
		(
			store.state.userTeam === 'EDITOR'
			|| store.state.userTeam === 'VIEWER'
		)
		&&
		(
			to.fullPath === '/usage'
			|| to.fullPath === '/team/billing'
			|| to.fullPath === '/team/plans'
		)
	) {
		next(process.env.VUE_APP_DEFAULT_PAGE)
		return
	}

	next()

})

export default router
